import React, { useEffect, useState } from "react";
import api from "../../services/api";

const OPTIONS = [
  { value: "pix", label: "Pix" },
  { value: "card", label: "Cartão de crédito" },
  { value: "boleto", label: "Boleto bancário" }
];

export default function VenturaPaymentMethodPicker({ value, onChange }) {
  const [methods, setMethods] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let cancelled = false;

    api.get("/billing/payment-methods")
      .then(({ data }) => {
        if (cancelled) return;
        if (!Array.isArray(data?.methods)) {
          throw new Error("Resposta inválida");
        }

        const allowed = data.methods.filter(method =>
          OPTIONS.some(option => option.value === method)
        );

        setMethods(allowed);
        setStatus(
          data.paymentRoutingActive === true ? "ready" : "pending"
        );
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });

    return () => { cancelled = true; };
  }, []);

  return (
    <div data-ventura-payment-methods="v1"
      style={{ marginTop: 16, marginBottom: 18 }}>
      <label htmlFor="ventura-payment-method">
        <strong>Como deseja pagar?</strong>
      </label>

      {status === "loading" && (
        <p>Consultando formas de pagamento...</p>
      )}

      {status === "error" && (
        <p role="alert">Não foi possível consultar os pagamentos.</p>
      )}

      {status === "pending" && (
        <p>As formas de pagamento estão em preparação.</p>
      )}

      {status === "ready" && methods.length === 0 && (
        <p>Nenhuma forma de pagamento disponível.</p>
      )}

      {status === "ready" && methods.length > 0 && (
        <select id="ventura-payment-method"
          value={value}
          onChange={event => onChange(event.target.value)}
          style={{
            display: "block",
            width: "100%",
            minHeight: 44,
            marginTop: 8,
            padding: 8,
            borderRadius: 6
          }}>
          <option value="">Selecione como deseja pagar</option>
          {OPTIONS.filter(option =>
            methods.includes(option.value)
          ).map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      )}

      {status === "ready" && methods.includes("boleto") && (
        <small>
          A liberação por boleto ocorre após confirmação do pagamento.
        </small>
      )}
    </div>
  );
}
